import api from './interceptor';

const BASE_URL_V1 = 'api/v1/schedules';

export default {
  // API Version 1
  getProviderSchedule: (params) => api.get(`${BASE_URL_V1}/`, { params }),
  createSchedule: (schedule) => api.post(`${BASE_URL_V1}?allDay=${schedule.allDay}`, schedule),
  updateSchedule: (schedule, scheduleId) => api.put(`${BASE_URL_V1}/${scheduleId}?allDay=${schedule.allDay}`, schedule),
  deleteSchedule: (scheduleId) => api.delete(`${BASE_URL_V1}/${scheduleId}`),
};
